import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
type Method = (() => void) & { _tId?: number };

export class W3ScrollHistory {
  isSwiper: boolean = false;
  isGsap: boolean = false;
  swiper: Swiper;
  slides: NodeListOf<Element>;

  constructor() {
    const scrollHistory = document.querySelector(".scroll-history");
    this.slides = document.querySelectorAll(".scroll-history__item");

    if (!scrollHistory) {
      return;
    }
    this.setupHistory();
  }

  /**
   * Setup scroll cards history based on window.innerWidth
   */
  private setupHistory() {
    const windowWidth = window.innerWidth;

    if (windowWidth <= 1024) {
      this.isSwiper = true;
      this.initHistorySlider();
    } else {
      this.isGsap = true;
      this.slides[0].classList.add("scroll-card--active");

      this.initScrollHistory();
    }

    window.addEventListener("resize", this.handleResize.bind(this));
  }

  /**
   * Handle resize event
   */

  private handleResize(): void {
    if (window.innerWidth <= 1024 && !this.isSwiper) {
      this.isSwiper = true;
      this.isGsap = false;
      this.initHistorySlider();
    } else if (window.innerWidth > 1024 && !this.isGsap) {
      this.isGsap = true;
      this.isSwiper = false;
      this.swiper.destroy();
      this.initScrollHistory();
    }
  }

  /**
   * Initialize mobile slider
   */
  initHistorySlider() {
    this.isSwiper = true;

    this.slides.forEach((item, i) => {
      item.classList.add("swiper-slide");
    });
    this.swiper = new Swiper(".scroll-history__slider", {
      modules: [Navigation, Pagination],
      spaceBetween: 28,
      loop: false,
      slidesPerView: 1,
      speed: 600,
      freeMode: false,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1025: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: ".scroll-history__next-button",
        prevEl: ".scroll-history__prev-button",
      },
      pagination: {
        el: ".scroll-history__pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1,
      },
      on: {
        slideChange: function (swiper) {
          swiper.slides.forEach((slide) => {
            slide.classList.remove("small-prev", "small-next");
          });
          if (swiper.activeIndex === 0) {
            swiper.slides[swiper.slides.length - 1].classList.add("small-prev");
          } else {
            swiper.slides[swiper.activeIndex - 1].classList.add("small-prev");
          }
          if (swiper.activeIndex >= swiper.slides.length - 3) {
            swiper.slides[0].classList.add("small-next");
          } else {
            swiper.slides[swiper.activeIndex + 3].classList.add("small-next");
          }
        },
      },
    });
  }

  /**
   * Initialize scroll cards animation with GSAP
   */
  initScrollHistory() {
    this.slides.forEach((item, i) => {
      item.classList.remove("swiper-slide");
    });
    let stickyDiv;
    this.isGsap = true;
    if (document.querySelector(".scroll-history__content-left p")) {
      stickyDiv = document.querySelector(".scroll-history__content-left p");
    } else {
      stickyDiv = document.querySelector(".scroll-history__content-left ");
    }
    const cards = document.querySelectorAll(".scroll-history__item");

    function calculateStickyDivTop() {
      const stickyRect = stickyDiv.getBoundingClientRect();
      const stickyTop = stickyRect.top;

      return stickyTop;
    }

    function checkIntersections() {
      const stickyDivTop = calculateStickyDivTop();

      let activeCard = null;
      cards.forEach((card) => {
        const cardRect = card.getBoundingClientRect();

        if (
          cardRect.top <= stickyDivTop + 100 &&
          cardRect.bottom >= stickyDivTop
        ) {
          activeCard = card;
        }
      });

      if (activeCard) {
        cards.forEach((card) =>
          card.classList.remove("scroll-history__item--active"),
        );
        activeCard.classList.add("scroll-history__item--active");
      }
    }

    window.addEventListener("scroll", checkIntersections);
    window.addEventListener("resize", checkIntersections);

    checkIntersections();
  }
}
